// import { FC } from "react";
// import { Col, Empty, Pagination, Skeleton, Table as AntTable } from "antd";
// import "./table.less";

// interface ITableColumn {
//   title: string;
//   dataIndex: string;
//   key: string;
//   width?: number;
// }

// interface ITable {
//   data: Array<Record<string, any>>;
//   columns: ITableColumn[];
//   onRowClick?: (record: Record<string, any>) => void;
//   locale?: any;
//   isLoading?: boolean;
//   page?: number;
//   pagination?: boolean;
//   onChangePage?: (page: number) => void;
//   onPageSizeChange?: React.Dispatch<React.SetStateAction<number>>;
//   count?: number;
//   scroll?: number;
//   scrollY?: number;
//   uniqueClass?: string;
//   onTableChange?: (pagination: any, filters: any, sorter: any) => void;
// }

// const COLUMN_WIDTH = 150; // 🔥 constant width (key fix)

// const Table: FC<ITable> = ({
//   columns,
//   data,
//   onRowClick,
//   pagination = false,
//   isLoading,
//   page = 1,
//   count = 10,
//   onChangePage,
//   locale,
//   scrollY,
//   onPageSizeChange,
//   onTableChange,
// }) => {
//   const lastColumn = columns[columns.length - 1];
//   const mainColumns = columns.slice(0, -1);

//   const totalWidth = mainColumns.length * COLUMN_WIDTH; // 🔥 stable width

//   const handlePageSizeChange = (current: number, pageSize: number) => {
//     onChangePage?.(1);
//     onPageSizeChange?.(pageSize);
//   };

//   return (
//     <Col span={24}>
//       <div className="tables-container">

//         {/* MAIN TABLE */}
//         <div className="main-table">
//           {/* <AntTable
//             key={mainColumns.map(c => c.key).join("-")} // 🔥 force reset
//             tableLayout="fixed"
//             onRow={(record: Record<string, any>) => ({
//               onClick: () => onRowClick && onRowClick(record),
//             })}
//             className={`table ${onRowClick ? "onRowHover" : ""} ${window.location.pathname.includes("client") ? "table--client" : ""
//               }`}
//             scroll={{ x: totalWidth }}
//             columns={mainColumns.map(col => ({
//               ...col,
//               width: col.width || COLUMN_WIDTH,
//             }))}
//             dataSource={isLoading ? [] : data}
//             onChange={onTableChange}
//             pagination={false}
//             rowKey="id"
//             locale={
//               !data?.length && !isLoading
//                 ? locale
//                 : {
//                   emptyText: isLoading ? (
//                     <>
//                       {[1, 2, 3, 4].map(x => (
//                         <Skeleton.Input key={x} size="small" active />
//                       ))}
//                     </>
//                   ) : (
//                     <Empty />
//                   ),
//                 }
//             }
//           /> */}

//           <AntTable
//             key={mainColumns.map(col => col.key).join("-")}
//             tableLayout="fixed"
//             onRow={(record: Record<string, any>) => ({
//               onClick: () => onRowClick?.(record),
//             })}
//             className={`table ${onRowClick ? "onRowHover" : ""} ${window.location.pathname.includes("client") ? "table--client" : ""
//               }`}
//             scroll={{ x: "100%" }}
//             columns={mainColumns.map(col => ({
//               ...col,
//               width: col.width,
//             }))}
//             dataSource={isLoading ? [] : data}
//             onChange={onTableChange}
//             pagination={false}
//             rowKey="id"
//             locale={
//               !data?.length && !isLoading
//                 ? locale
//                 : {
//                   emptyText: isLoading ? (
//                     <>
//                       {[1, 2, 3, 4].map(x => (
//                         <Skeleton.Input key={x} size="small" active />
//                       ))}
//                     </>
//                   ) : (
//                     <Empty />
//                   ),
//                 }
//             }
//           />
//         </div>

//         {/* LAST COLUMN TABLE */}
//         {lastColumn && (
//           <div className="last-column-table">
//             <AntTable
//               key={lastColumn.key} // 🔥 force reset
//               tableLayout="fixed"
//               className="last-column-table-inner"
//               columns={[
//                 {
//                   ...lastColumn,
//                   width: lastColumn.width || COLUMN_WIDTH,
//                 },
//               ]}
//               dataSource={isLoading ? [] : data}
//               pagination={false}
//               rowKey="id"
//               scroll={{ x: COLUMN_WIDTH }}
//               locale={
//                 !data?.length && !isLoading
//                   ? locale
//                   : {
//                     emptyText: isLoading ? (
//                       <>
//                         {[1, 2, 3, 4].map(x => (
//                           <Skeleton.Input key={x} size="small" active />
//                         ))}
//                       </>
//                     ) : (
//                       <Empty />
//                     ),
//                   }
//               }
//             />
//           </div>
//         )}
//       </div>

//       {/* PAGINATION */}
//       {data?.length && pagination ? (
//         <div className="table__pagination">
//           <Pagination
//             onChange={onChangePage}
//             current={page}
//             total={count}
//             showSizeChanger
//             onShowSizeChange={handlePageSizeChange}
//             pageSizeOptions={["10", "20", "50", "100"]}
//           />
//         </div>
//       ) : null}
//     </Col>
//   );
// };

// export default Table;


// v2
import { FC } from "react";
import {
  Col,
  Empty,
  Pagination,
  Skeleton,
  Table as AntTable,
} from "antd";
import "./table.less";

interface ITableColumn {
  title: string;
  dataIndex?: string;
  key: string;
  width?: number | string;
  [key: string]: any;
}

interface ITable {
  data: Array<Record<string, any>>;
  columns: ITableColumn[];
  onRowClick?: (record: Record<string, any>) => void;
  locale?: any;
  isLoading?: boolean;
  page?: number;
  pagination?: boolean;
  onChangePage?: (page: number) => void;
  onPageSizeChange?: React.Dispatch<React.SetStateAction<number>>;
  count?: number;
  scroll?: number;
  scrollY?: number;
  uniqueClass?: string;
  onTableChange?: (
    pagination: any,
    filters: any,
    sorter: any
  ) => void;
}

const COLUMN_WIDTH = 150;

const Table: FC<ITable> = ({
  columns,
  data,
  onRowClick,
  pagination = false,
  isLoading,
  page = 1,
  count = 10,
  onChangePage,
  locale,
  scrollY,
  onPageSizeChange,
  onTableChange,
}) => {
  const lastColumn = columns[columns.length - 1];

  // Split only if the actual last column is an action column
  const shouldSplit =
    lastColumn?.key === "actions" ||
    lastColumn?.key === "action";

  const mainColumns = shouldSplit
    ? columns.slice(0, -1)
    : columns;

  const fixedColumns = shouldSplit
    ? columns.slice(-1)
    : [];

  const totalWidth = mainColumns.length * COLUMN_WIDTH;

  const handlePageSizeChange = (
    current: number,
    pageSize: number
  ) => {
    onChangePage?.(1);
    onPageSizeChange?.(pageSize);
  };

  return (
    <Col span={24}>
      <div className="tables-container">
        {/* MAIN TABLE */}
        <div className="main-table">
          <AntTable
            key={mainColumns.map(col => col.key).join("-")}
            tableLayout="fixed"
            onRow={(record: Record<string, any>) => ({
              onClick: () => onRowClick?.(record),
            })}
            className={`table ${
              onRowClick ? "onRowHover" : ""
            } ${
              window.location.pathname.includes("client")
                ? "table--client"
                : ""
            }`}
            scroll={{
              x: "100%",
              ...(scrollY ? { y: scrollY } : {}),
            }}
            columns={mainColumns.map(col => ({
              ...col,
              width: col.width,
            }))}
            dataSource={isLoading ? [] : data}
            onChange={onTableChange}
            pagination={false}
            rowKey="id"
            locale={
              !data?.length && !isLoading
                ? locale
                : {
                    emptyText: isLoading ? (
                      <>
                        {[1, 2, 3, 4].map(x => (
                          <Skeleton.Input
                            key={x}
                            size="small"
                            active
                          />
                        ))}
                      </>
                    ) : (
                      <Empty />
                    ),
                  }
            }
          />
        </div>

        {/* ACTION COLUMN TABLE */}
        {shouldSplit && fixedColumns.length > 0 && (
          <div className="last-column-table">
            <AntTable
              key={fixedColumns.map(col => col.key).join("-")}
              tableLayout="fixed"
              className="last-column-table-inner"
              columns={fixedColumns.map(col => ({
                ...col,
                width: col.width || COLUMN_WIDTH,
              }))}
              dataSource={isLoading ? [] : data}
              pagination={false}
              rowKey="id"
              scroll={{
                x: fixedColumns.reduce(
                  (sum, col) =>
                    sum +
                    (typeof col.width === "number"
                      ? col.width
                      : COLUMN_WIDTH),
                  0
                ),
                ...(scrollY ? { y: scrollY } : {}),
              }}
              locale={
                !data?.length && !isLoading
                  ? locale
                  : {
                      emptyText: isLoading ? (
                        <>
                          {[1, 2, 3, 4].map(x => (
                            <Skeleton.Input
                              key={x}
                              size="small"
                              active
                            />
                          ))}
                        </>
                      ) : (
                        <Empty />
                      ),
                    }
              }
            />
          </div>
        )}
      </div>

      {/* PAGINATION */}
      {data?.length && pagination ? (
        <div className="table__pagination">
          <Pagination
            onChange={onChangePage}
            current={page}
            total={count}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            pageSizeOptions={["10", "20", "50", "100"]}
          />
        </div>
      ) : null}
    </Col>
  );
};

export default Table;